import React from 'react';
import './OptionCard.scss';
import classNames from 'classnames';

const BasicOptionCard = props => {
  const { title, selected, onClick, padding, fontSize = '16px' } = props;

  const paddingClass = () => {
    if (padding === 'lg') return 'padding-lg';
    if (padding === 'md') return 'padding-md';
    if (padding === 'sm') return 'padding-sm';

    return 'padding-xs';
  };

  const renderTitle = () => {
    if (title.includes('\n')) {
      return title.split('\n').map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index < title.split('\n').length - 1 && <br />}
        </React.Fragment>
      ));
    }
    return title;
  };

  return (
    <div
      className={classNames(`${paddingClass()} option-card basic-option-card`, {
        selected: selected,
      })}
      onClick={onClick}
    >
      <p className={`card-title`} style={{ fontSize: fontSize }}>
        {renderTitle()}
      </p>
    </div>
  );
};

export default BasicOptionCard;
